import React, { useEffect, useState } from 'react'
import useStateRef from 'react-usestateref';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import OrderSummary from './OrderSummary';
import { useHistory } from 'react-router';
import Loader from '../Loader/Loader';
import NonLivingCalenderV1 from './NonLivingCalenderV1';
import SpecialItemCalenderModalV1 from './SpecialItemCalenderModalV1';
import moment from 'moment';
import Helper from '../Helper';
import LivingCalendarModalV1 from './LivingCalendarModalV1';
import { useSelector } from 'react-redux';

const CheckOutDeliveryV1 = ({ containerObject, templateName, contentId, dataZone }) => {
  const [deliveryDetails, setdeliveryDetails, deliveryDetailsRef] = useStateRef();
  const [repeatCall, setRepeatCall, repeatCallRef] = useStateRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [myOrderBoxFix, setMyOrderBoxFix] = useState(false);
  const [livingShipMethod, setLivingShipMethod, livingShipMethodRef] = useStateRef();
  const [nonLivingShipMethod, setNonLivingShipMethod, nonLivingShipMethodRef] = useStateRef("");
  const [nonLivingShipGroupMethod, setNonLivingShipGroupMethod, nonLivingShipGroupMethodRef] = useStateRef("");
  let startAndEndDate = ["dropShippedResponseItemList", "groundOnlyItemResponseItemList", "rtsProductsResponseItemList"];
  let specialListOrder = ["dropShippedResponseItemList", "groundOnlyItemResponseItemList", "softGoodResponseItemList", "backorderProductsResponseItemList", "rtsProductsResponseItemList"];
  let livingListOrder = ["spLivingMaterialItemList", "livingMaterialItemList"];
  const history = useHistory();
  const [dateTriggered, setDateTriggered] = useState(true);
  const [detailFlag, setDetailFlag] = useState(true);
  const [formattedCurrentDate, setFormattedCurrentDate, formattedCurrentDateRef] = useStateRef('');
  const [previousShippingMethodState, setPreviousShippingMethodState, previousShippingMethodStateRef] = useStateRef('Standard Ground')
  const [nonLivingMap, setNonLivingMap, nonLivingMapRef] = useStateRef();
  const [onlyLivingMap, setOnlyLivingMap, onlyLivingMapRef] = useStateRef();
  const [specialLivingMap, setSpecialLivingMap, specialLivingMapRef] = useStateRef();
  const [isOrderSummaryLoading, setOrderSummaryLoading, isOrderSummaryLoadingRef] = useStateRef(false);

  const [specialNotAvailableMethod, setSpecialNotAvailableMethod, specialNotAvailableMethodRef] = useStateRef('');
  const [specialAlternateDate, setSpecialAlternateDate, specialAlternateDateRef] = useStateRef('');
  const [selectedItemSpecial, setSelectedItemSpecial, selectedItemSpecialRef] = useStateRef('');
  const [showDateSpecial, setShowDateSpecial, showDateSpecialRef] = useStateRef(new Date());
  const [selectedDateSpecialItem, setSelectedDateSpecialItem, selectedDateSpecialItemRef] = useStateRef(null);
  const [currentDateSpecial, setCurrentDateSpecial] = useState('');
  const [shippingSpecialCalendarPrevious, setShippingSpecialCalendarPrevious] = useState('');
  const [shippingOptionCalendarSpecial, setShippingOptionCalendarSpecial, shippingOptionCalendarSpecialRef] = useStateRef('');
  const [livingFlag, setLivingFlag, livingFlagRef] = useStateRef(false);
  const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef("");
  var fieldNames = ["firstName", "lastName", "emailAddress", "phoneNumber", "companyName", "address1", "address2", "postalCode", "city", "state"]
  const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
  useEffect(() => {
    if (loaderStatus == true) {
      console.log("log in delivery page loader true");
    } else {
      console.log("log in delivery page loader false");
      if (window.location.pathname == "/checkout/delivery") {
        setLocalStorageData(fieldNames)
        handleOrderDetails()
      }
    }
  }, [])




  function setLocalStorageData(fields) {
    fields.map((oneData) => {
      localStorage.removeItem(oneData);
    })
  }

  function handleOrderDetails() {
    setIsLoading(true)
    fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/delivery-detailsV1`, {
      //    fetch(`${window.location.protocol}//${window.location.hostname}/gateway/api/v1/delivery/service/deliveryDetails`, {
      method: 'GET'
    }).then(res => res.json())
      .then(res => {
        if (res.result === "success") {

          var deliveryDetailRes = (JSON.parse(res.response)).response
          console.log("CheckOutDeliveryV1", deliveryDetailRes);
          setdeliveryDetails('');
          setdeliveryDetails(deliveryDetailRes);
          getOrderSummaryDetails();
          handleLivingEditData()

        }
      })
  }

  function handleCallBackOrderSummary() {
    getOrderSummaryDetails();
  }
  const getOrderSummaryDetails = async () => {
    console.log("getOrderSummaryDetails fired");
    setOrderSummaryLoading(true);
    const body = {
      "isReviewPage": false,
      "isShippingPage": false,
      "requiredReprice": true
    }
    var orderSummary = await Helper.getOrderSummary(body);
    console.log("getOrderSummaryDetails", orderSummary);
    setOrderSummaryDetails(orderSummary);
    setOrderSummaryLoading(false);
    if (document.getElementById('checkoutDelivery')) {
      if (document.getElementById('checkoutDelivery').classList.contains('pe-none')) {
        document.getElementById('checkoutDelivery').classList.remove('pe-none')
      }
      if (!document.getElementById('checkoutDelivery').classList.contains('pe-auto')) {
        document.getElementById('checkoutDelivery').classList.add('pe-auto')
      }
    }
    setIsLoading(false)
  }


  function handleShowSpecialItemList() {

    let special = deliveryDetailsRef.current?.displaySpecialItemsContent;
    if (special) {
      for (let i = 0; i < specialListOrder.length; i++) {
        let oneId = specialListOrder[i];
        let listSize = special[oneId].length;
        if (listSize > 0) {
          return true;
        }
      }
    }
    return false;

  }

  async function handleSubmitContinue(event) {
    event.preventDefault();
    var actionUrl = "api/rest/cb/checkout/continue-billing";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    if (orderSummaryDetailsRef.current) {
      var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
        sessionExpirationURL: "/checkout/login",
        moveToBillingSuccessURL: "/checkout/billing",
        moveToBillingErrorURL: "/checkout/delivery",
        moveToBilling: "Continue"
      }))
      if (res.result == "success") {
        history.push('/checkout/billing', '/checkout/delivery')
      }
      else {
        console.log("errorList-----", res)
      }
    } else {
      console.log("Kindly wait still order summary is loading");
    }
  }


  async function handleMethodLiving(event, method) {
    event.preventDefault()

    if (method != livingShipMethodRef.current && method === 'shipAllTogether' && livingFlagRef.current === true && repeatCallRef.current == false) {
      setLivingShipMethod(method)
      handleRepeatCallRestrict()
      await handleshipAllTogether(event);
    } else {
      setLivingShipMethod(method)
      setLivingFlag(false)
    }
  };

  async function handleshipAllTogether(event) {
    event.preventDefault()
    setIsLoading(true)
    setRepeatCall(true)
    let currentDate = deliveryDetailsRef.current?.displayLivingMaterialContent?.comDate
    let currentShipMethod = deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMatShipMethod
    if (currentDate) {
      currentDate = handleDateFormat(deliveryDetailsRef.current?.displayLivingMaterialContent?.comDate)
    } else {
      currentDate = ""
    }

    if (!currentShipMethod) {
      currentShipMethod = ""
    }
    var actionUrl = "api/rest/cb/checkout/ship-later";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
      groupName: "KEY_LIVING_MATERIAL",
      // currentDate: deliveryDetailsRef.current?.livingMaterialItemShippingMap?.deliveryDate ? deliveryDetailsRef.current.livingMaterialItemShippingMap.deliveryDate :'',
      currentDate: currentDate,
      currentShipMethod: currentShipMethod,
      changewithBoxSelection: "true"
    }))
    if (res.result == "success") {
      setRepeatCall(false)
      handleOrderDetails()
    }
    else {
      setRepeatCall(false)
      console.log("errorList-----", res)
    }

  }
  function handleLivingEditData() {
    // setting  living ship method
    console.log("handleLivingEditData fireddd");
    if (deliveryDetailsRef.current?.displayLivingMaterialContent?.lmdeliveredOnSameDate && deliveryDetailsRef.current?.displayLivingMaterialContent?.lmdeliveredOnSameDate == true) {


      if (deliveryDetailsRef.current && deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMaterialItemList?.length > 1 && deliveryDetailsRef.current?.displayLivingMaterialContent?.spLivingMaterialItemList?.length == 0) {
        setLivingShipMethod("shipAllTogether")
      } else {
        setLivingShipMethod("shipSeperately")
        setLivingFlag(true)
      }
    } else {
      setLivingShipMethod("shipSeperately")
      setLivingFlag(true)
    }
    // setting non living ship method
    if (deliveryDetailsRef.current?.displayNonLivingContent?.shippingPreferenceForNonLiving && deliveryDetailsRef.current?.displayNonLivingContent?.shippingPreferenceForNonLiving) {
      setNonLivingShipMethod(deliveryDetailsRef.current?.displayNonLivingContent?.shippingPreferenceForNonLiving)
    } else {
      setNonLivingShipMethod("ship-Immediate")
    }
    // setting non living ship group
    if (deliveryDetailsRef.current?.displayNonLivingContent?.shipGroupMap?.activeShipMethod) {
      setNonLivingShipGroupMethod(deliveryDetailsRef.current?.displayNonLivingContent?.shipGroupMap?.activeShipMethod)
    }
  }
  function handleShowLivinglItemList() {

    let living = deliveryDetailsRef.current?.displayLivingMaterialContent;

    if (living) {
      for (let i = 0; i < livingListOrder.length; i++) {

        let oneId = livingListOrder[i];
        let listSize = living[oneId].length;
        if (listSize > 0) {
          return true;
        }
      }
    }
    return false;

  }

  function replaceImage(event) {

    event.target.src = DEFAULT_IMAGE_140;

  }

  function handleDateCompare(start, end) {
    let startDate = handleDateFormat(start)
    let endDate = handleDateFormat(end)
    if (startDate == endDate) {
      return "equal"
    }
    return "notEqual"
  }
  function handleDateFormat(dates) {
    let date = new Date(dates);
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // JavaScript months are 0-indexed
    let day = date.getDate();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    var formattedDate = month + '/' + day + '/' + year;
    return formattedDate;
  }

  function handleCurrentDateFormat() {
    const date = new Date();
    // Check if current day is Sunday (0) or Saturday (6)
    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
    if (nonLivingShipGroupMethodRef.current === 'Standard Ground') {
      if (!isWeekend) {
        date.setDate(date.getDate() + 3);
      } else {
        date.setDate(date.getDate() + 5);
      }

    }
    if (nonLivingShipGroupMethodRef.current === 'Second Day Air') {
      if (!isWeekend) {
        date.setDate(date.getDate() + 2);
      } else {
        date.setDate(date.getDate() + 4);
      }

    }
    if (nonLivingShipGroupMethodRef.current === 'Overnight') {
      if (!isWeekend) {
        date.setDate(date.getDate() + 1);
      } else {
        date.setDate(date.getDate() + 2);
      }

    }

    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    return formattedDate;
  }





  async function handleshipLater(event, shipLater) {
    event.preventDefault();
    if (nonLivingShipMethodRef.current == shipLater) { }
    else {
      setIsLoading(true)
      setNonLivingShipMethod(shipLater);
      var actionUrl = "api/rest/cb/checkout/ship-later";
      var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`

      var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
        groupName: "KEY_NON_LIVE_ITEMS",
        currentDate: handleDateFormat(deliveryDetailsRef.current?.displayNonLivingContent?.comDate),
        currentShipMethod: nonLivingShipGroupMethodRef.current,
        changewithBoxSelection: "true"
      }))


      if (res.result == "success") {

      }
      else {
        console.log("errorList-----", res)
      }
      handleOrderDetails()
    }
  }



  const handleNonLivingShippingMethod = async (event, method) => {
    if (method != nonLivingShipGroupMethodRef.current) {
      event.preventDefault();
      setPreviousShippingMethodState(nonLivingShipGroupMethodRef.current)
      setNonLivingShipGroupMethod(method)
      await handleFetchCall(event, method);
    }
  };

  const handleFetchCall = async (event, selectedMethod) => {
    event.preventDefault();
    setIsLoading(true)
    handleRepeatCallRestrict()

    const actionUrl = "api/rest/cb/checkout/ship-immediate";
    console.log('previousShippingMethodStateRef.current---', previousShippingMethodStateRef.current)
    const Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
    try {
      const res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
        previousShippingMethod: previousShippingMethodStateRef.current,
        groupName: "KEY_NON_LIVE_ITEMS",
        modifiedShippingMethod: nonLivingShipGroupMethodRef.current,
        moveToBillingSuccessURL: "/checkout/billing",
        moveToBillingErrorURL: "/checkout/delivery",
        shippingMethodCall: "true"
      }));

      if (res.result === "success") {

      } else {
        console.log("Error:", res);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    handleOrderDetails()
  };

  const handleRepeatCallRestrict = () => {
    if (document.getElementById('checkoutDelivery').classList.contains('pe-auto')) {
      document.getElementById('checkoutDelivery').classList.remove('pe-auto')
    }
    if (!document.getElementById('checkoutDelivery').classList.contains('pe-none')) {
      document.getElementById('checkoutDelivery').classList.add('pe-none')
    }
  };


  async function handleShipImmediately(event, shipImmediate) {
    event.preventDefault();
    handleRepeatCallRestrict()
    setNonLivingShipMethod(shipImmediate);
    await handleFetchCall(event, shipImmediate);

  }

  async function handleNonLivingModal(event, method) {
    console.log("handleNonLivingModal fireddd");
    event.preventDefault();
    var actionUrl = "api/rest/cb/checkout/deliveryDates";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
      groupName: "KEY_NON_LIVE_ITEMS",
      shipType: method,
      itemType: "nonLivingItems",
    }))
    if (res.result == "success") {
      console.log("res success", res);
      let dataMap = {
        message: deliveryDetailsRef.current?.displayMessagesMap?.checkout_delivery_livingItems_userInfo,
        dates: JSON.parse(res.response).response,
        currentDate: handleDateFormat(deliveryDetailsRef.current?.displayNonLivingContent?.comDate)
      }
      setNonLivingMap(dataMap)
      document.getElementById("nonLivingOpenModal").click();

      setOnlyLivingMap(dataMap)
    } else {
      console.log("res error", res);
    }

  }


  async function handleOnlyLivingModal(event, oneSpecial, noGroup) {
    setLivingFlag(true)
    console.log("handleOnlyLivingModal oneSpecial", oneSpecial);
    console.log("handleOnlyLivingModal noGroup", noGroup);
    event.preventDefault();
    var actionUrl = "api/rest/cb/checkout/deliveryDates";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
      shipType: oneSpecial?.shippingMethod,
      itemType: "livingItems",
      itemNumber: oneSpecial?.itemNumber,
      currentDate: oneSpecial?.deliveryDate,

    }))
    if (res.result == "success") {
      console.log("res success", res.response);
      console.log("res success", JSON.parse(res.response).response);
      let dataMap = {
        group: noGroup == "noGroup" ? false : true,
        dates: JSON.parse(res.response).response,
        oneSpecial: oneSpecial,
        message: deliveryDetailsRef.current?.displayMessagesMap?.checkout_delivery_livingItems_userInfo
      }
      setOnlyLivingMap(dataMap)
      document.getElementById("LivingOpenModal").click();
    } else {
      console.log("res error", res);
    }

  }

  async function handleLivingSpecialModal(event, method, date) {
    console.log("handleLivingSpecialModal fireddd");
    event.preventDefault();
    var actionUrl = "api/rest/cb/checkout/deliveryDates";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
      groupName: "KEY_LIVING_MATERIAL",
      shipType: method,
      itemType: "livingItems",
      itemNumber: "",
      currentDate: handleDateFormat(date),

    }))
    if (res.result == "success") {
      console.log("res success", res.response);
      console.log("res success", JSON.parse(res.response).response);
      let dataMap = {
        currentDate: date,
        group: true,
        shipType: method,
        dates: JSON.parse(res.response).response,
        message: deliveryDetailsRef.current?.displayMessagesMap?.checkout_delivery_livingItems_userInfo
      }
      setOnlyLivingMap(dataMap)
      document.getElementById("LivingOpenModal").click();
    } else {
      console.log("res error", res);
    }

  }


  async function handleSpecialModal(event, oneSpecial, indexSpecial) {
    event.preventDefault();
    console.log("handleSpecialModal oneSpecial", oneSpecial);
    const index = event.currentTarget.getAttribute("index")
    var actionUrl = "api/rest/cb/checkout/deliveryDates";
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
      // groupName: oneSpecial?.groupName,
      // itemType: oneSpecial?.isDropShippedItem === true ? "dropshipped" : "backorder", 
      // shipType: "DropShip",
      itemType: "DropShip",
      shipType: oneSpecial?.isDropShippedItem === true ? "DropShip" : "BackOrder",
      itemNumber: oneSpecial?.itemNumber,
      currentDate: oneSpecial?.deliveryDate ? handleDateFormat(oneSpecial?.deliveryDate) : ''
    }))

    if (res.result == "success") {
      console.log("res success", res);
      var dates = (JSON.parse(res.response)).response
      console.log("special item", dates);
      let dataMap = {
        dates: dates,
        oneSpecial: oneSpecial,
        deliveryDate: oneSpecial?.deliveryDate,
        message: deliveryDetailsRef.current?.displayMessagesMap?.checkout_delivery_livingItems_userInfo
      }
      setSpecialLivingMap(dataMap)
      console.log('specialLivingMapRef--', specialLivingMapRef.current)
      document.getElementById(`specialOpenModal${index}`).click();
      console.log('specialItemBtn---', document.getElementById(`specialOpenModal${index}`))
    } else {
      console.log("res error", res);
    }

  }

  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-container c-delivery-header  `}>
      {isLoading && <Loader />}
      <p className="m-0" id="nonLivingOpenModal" data-bs-toggle="modal" data-bs-target="#nonLiving-calendar-modalV1" />
      <p className="m-0" id="LivingOpenModal" data-bs-toggle="modal" data-bs-target="#livingCalendar" />
      <p className="m-0" id="specialOpenModal" data-bs-toggle="modal" data-bs-target="#specialItemModal" />
      <div id="checkoutDelivery" className="row pe-auto justify-content-center c-school-page c-shipping-page c-delivery-page">
        <div className="col-12 col-md-11 my-md-5 my-2">
          <div className="row">
            <div id="visibleElement" className="col-12 col-md-8">&nbsp;
              {/* need to handle success message for b2c user */}
              {/* {deliveryDetailsRef.current?.accountSuccessMsgForb2c ?
                <div className="d-block alert alert-danger alert-yellow ml-5 mb-3 mr-auto ml-auto">
                  <p className="black-color">
                    {deliveryDetailsRef.current && deliveryDetailsRef.current.accountSuccessMsgForb2c}
                  </p>
                </div>
                : ""} */}
              {deliveryDetailsRef.current && handleShowSpecialItemList() == true ? <>
                <div className="c-delivery-wrapper mb-4">
                  <p className="text-left mb-1 c-delivery-text c-red-color">Notice: Special Items</p>
                  <p className="text-left mb-2 c-delivery-text fw-light">
                    Special Order Items have specific arrival timeframes, and many require several-week lead times for culturing or preparation.
                  </p>
                </div>
                <div className="row mb-2">
                  <div className="col-8 col-md-8">
                  </div>
                  <div className="col-4 col-md-4">
                    <p className="text-left mb-2 c-delivery-text">
                      Est. Arrival Date
                    </p>
                  </div>
                </div>
                <div className="mb-10">
                  {specialListOrder.map((oneOrder) => {
                    return (
                      <>
                        {deliveryDetailsRef.current?.displaySpecialItemsContent[oneOrder] && deliveryDetailsRef.current?.displaySpecialItemsContent[oneOrder].length > 0 ?
                          deliveryDetailsRef.current.displaySpecialItemsContent[oneOrder].map((oneProduct, index) => {
                            return (<>
                              <div className="row mb-3">
                                <div className="col-8 col-md-8">
                                  <div className="c-delivery-item">
                                    <span className="c-delivery-img">
                                      <img fetchpriority="high" onError={replaceImage} src={oneProduct?.imagePath} />
                                    </span>
                                    <div className="c-delivery-items">
                                      {oneOrder == "dropShippedResponseItemList" || oneOrder == "backorderProductsResponseItemList" ?
                                        <p className="c-delivery-item-text">
                                          {oneProduct?.isBackOrdered && oneProduct?.isBackOrdered == true ? deliveryDetailsRef.current?.displayMessagesMap?.backorder_msg :
                                            oneProduct?.isDropShippedItem && oneProduct?.isDropShippedItem == true ? deliveryDetailsRef.current?.displayMessagesMap?.dropShipItem_msg :
                                              oneProduct?.isHazardousItem && oneProduct?.isHazardousItem == true ? deliveryDetailsRef.current?.displayMessagesMap?.hazardousItem_msg : ""}
                                        </p>
                                        :
                                        oneOrder == "groundOnlyItemResponseItemList" ?
                                          <p className="c-delivery-item-text">{deliveryDetailsRef.current?.displayMessagesMap?.deliveryGroundOnly}</p>
                                          :
                                          oneOrder == "softGoodResponseItemList" ?
                                            <p className="c-delivery-item-text">{deliveryDetailsRef.current?.displayMessagesMap?.deliverySoftGood}</p> :
                                            oneOrder == "rtsProductsResponseItemList" ?
                                              oneProduct?.isBackOrdered && oneProduct?.isBackOrdered == true ?
                                                <p className="c-delivery-item-text">{deliveryDetailsRef.current?.displayMessagesMap?.backorder_msg}</p> :
                                                <p className="c-delivery-item-text">{deliveryDetailsRef.current?.displayMessagesMap?.deliveryrtsProduct}</p>
                                              : ""}
                                      <p className="c-delivery-item-text fw-light">{`#${oneProduct?.itemNumber}  Qty:${oneProduct?.quantity}`}</p>
                                      <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: oneProduct?.productDescription }}></p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4 col-md-4 align-self-center">
                                  {startAndEndDate.includes(oneOrder) ? <p className="text-left mb-0 c-delivery-content">
                                    {handleDateFormat(oneProduct.arrivalStartDate).concat(" - ").concat(handleDateFormat(oneProduct.arrivalEndDate))}
                                  </p> : oneOrder == "softGoodResponseItemList" ?
                                    <p className="text-left mb-0 c-delivery-content">Electronic Delivery</p>
                                    : oneOrder == "backorderProductsResponseItemList" ?
                                      <div className="row">
                                        <div className="col-12 col-md-6">
                                          <p className="text-left mb-0 c-delivery-content">
                                            {handleDateFormat(oneProduct.arrivalStartDate)}
                                          </p>
                                          <p className="text-left mb-0 c-delivery-content">
                                            {/* special item shipMethod show only for backOrderItem*/}
                                            {oneProduct?.shippingMethod === "Second Day Air" ? "2 Day Air" : oneProduct?.shippingMethod}
                                          </p>
                                        </div>
                                        
                                        {oneProduct?.shippingMethod == "USPS" ? "" :
                                        <div className="col-12 col-md-6">
                                          {/* <button className="btn btn-outline-secondary c-shipping-change-btn modal-link" data-bs-toggle="modal" data-bs-target={`#specialItem-calendar${index}`} onClick={(event) => handleSpecialModal(event, oneProduct, index)}>edit</button> */}
                                          <button className="btn btn-outline-secondary c-shipping-change-btn modal-link" index={index} onClick={(event) => handleSpecialModal(event, oneProduct, index)}>edit</button>
                                        </div>}
                                      </div> : ""}
                                </div>
                              </div >
                              <p className="m-0" id={`specialOpenModal${index}`} data-bs-toggle="modal" data-bs-target={`#specialItemModal${index}`} />

                              {specialLivingMapRef.current ? <SpecialItemCalenderModalV1
                                index={index}
                                currentData={specialLivingMapRef.current}
                                handleOrderDetails={handleOrderDetails} /> : ""}
                            </>)
                          })
                          : ""}

                      </>)
                  })}

                </div>

              </> : ""}


              {/* living product */}
              {deliveryDetailsRef.current && handleShowLivinglItemList() == true ? <>

                <div className="row">
                  <div className="col-12 col-md-12 text-left mb-3">
                    <h1 className="c-account-heading fw-bold">{deliveryDetailsRef.current?.displayMessagesMap?.deliveryLivingContainer_header}</h1>
                  </div>
                </div>

                {deliveryDetailsRef.current && deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMaterialItemList?.length > 1 && deliveryDetailsRef.current?.displayLivingMaterialContent?.spLivingMaterialItemList?.length == 0 ?
                  <form className="row g-4 mb-5">
                    <div className="col-12 col-md-12 text-left mb-3">
                      <h1 className="c-account-heading fw-normal">{deliveryDetailsRef.current?.displayMessagesMap?.deliverySelect_shipPreferences}</h1>
                    </div>
                    <label className="col-12 col-md-6" htmlFor="ship-all-together" onClick={(event) => handleMethodLiving(event, "shipAllTogether")}>
                      <div className={`c-box-shipping ${livingShipMethodRef.current === 'shipAllTogether' && 'active'}`}>
                        <div className="form-check">
                          <input className="form-check-input"
                            type="radio"
                            name="delivery-live-toggle"
                            id="ship-all-together"
                            value="shipAllTogether"
                            checked={livingShipMethodRef.current === 'shipAllTogether'}
                            defaultChecked={livingShipMethodRef.current === 'shipAllTogether'}
                            onChange={(event) => handleMethodLiving(event, "shipAllTogether")}
                          />
                          <div className="form-check-label">
                            Ship All Together
                          </div>
                        </div>
                        <div className="c-box-calendar-info fst-italic">
                          <p>I want everything the same day</p>
                        </div>
                        <div className="c-box-shipping-calendar">
                          <p className="c-box-calendar-icon me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                              <g>
                                <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                  <title>calendar</title>
                                  <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                  </path>
                                </svg></g>
                              </g>
                            </svg>
                          </p>
                          {livingShipMethodRef.current === 'shipAllTogether' ?
                            <div className="shipTogetherActive c-box-calendar-info c-box-calendar-active-info">

                              <p>{deliveryDetailsRef.current?.displayLivingMaterialContent?.comDay}, {deliveryDetailsRef.current?.displayLivingMaterialContent?.comDate ? handleDateFormat(deliveryDetailsRef.current?.displayLivingMaterialContent?.comDate) : ""}</p>
                              <p>
                                Shipping:&nbsp;
                                {deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMatShipMethod == "Second Day Air" ? "2 Day Air" : deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMatShipMethod}
                              </p>
                            </div> : ""}

                          <div className="shipTogetherActive" >
                            {livingShipMethodRef.current === 'shipAllTogether' ?
                              <div className="btn btn-outline-secondary c-shipping-change-btn" id="select-arrival-button" onClick={(event) => handleLivingSpecialModal(event, deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMatShipMethod, deliveryDetailsRef.current?.displayLivingMaterialContent?.comDate)} >edit</div>
                              : <div className="btn btn-outline-secondary c-shipping-change-btn">Select Arrival Date</div>}
                          </div>
                        </div>
                        <div className="container-circle">
                          <div className="circle">
                          </div>
                        </div>
                      </div>
                    </label>




                    <label className="col-12 col-md-6" htmlFor="ship-separately" onClick={(event) => handleMethodLiving(event, "shipSeperately")}>
                      <div className={`c-box-shipping ${livingShipMethodRef.current && livingShipMethodRef.current == "shipSeperately" && 'active'}`}>
                        <div className="form-check">
                          <input className="form-check-input"
                            type="radio"
                            name="delivery-live-toggle"
                            id="ship-Seperately"
                            value="shipSeperately"
                            checked={livingShipMethodRef.current && livingShipMethodRef.current == "shipSeperately"}
                            defaultChecked={livingShipMethodRef.current && livingShipMethodRef.current == "shipSeperately"}
                            onChange={(event) => handleMethodLiving(event, "shipSeperately")}
                          />
                          <div className="form-check-label">
                            Ship Separately
                          </div>
                        </div>
                        <div className="c-box-shipping-calendar">
                          <div className="c-box-calendar-info fst-italic">
                            <p>I want items on different days</p>
                          </div>
                        </div>

                        <div className="container-circle">
                          <div className="circle">
                          </div>
                        </div>
                      </div>



                    </label>
                  </form> : ""}

                <div className="row mb-2">
                  <div className="col-8 col-md-8">
                  </div>
                  <div className="col-4 col-md-4">
                    <p className="text-left mb-2 c-delivery-text">Arrival Date</p>
                  </div>
                </div>
                <div className="mb-10">
                  {/* livingItemList */}
                  {deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMaterialItemList?.length > 0 ?
                    <>

                      {deliveryDetailsRef.current?.displayLivingMaterialContent?.livingMaterialItemList.map((oneSpecial, index) => {
                        return (<>
                          <div className="row mb-3">
                            <div className="col-8 col-md-8">
                              <div className="c-delivery-item">
                                <span className="c-delivery-img">
                                  <img fetchpriority="high" onError={replaceImage} src={oneSpecial?.imagePath} />
                                </span>
                                <div className="c-delivery-items c-delivery-items-weight">
                                  <p className="c-delivery-item-text fw-light">{`#${oneSpecial?.itemNumber}  Qty:${oneSpecial?.quantity}`}</p>
                                  <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: oneSpecial?.productDescription }}></p>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 col-md-4 align-self-center">
                              <div className="row">
                                <div className="col-12 col-md-6">
                                  <p className="text-left mb-0 c-delivery-content">
                                    {handleDateFormat(oneSpecial?.deliveryDate)}
                                  </p>{livingShipMethodRef.current == "shipAllTogether" ? "" :
                                    <p className="text-left mb-0 c-delivery-content livShipMethod">{oneSpecial?.shippingMethod === "Second Day Air" ? "2 Day Air" : oneSpecial?.shippingMethod}</p>
                                  }
                                </div>
                                {livingShipMethodRef.current == "shipAllTogether" ? "" :
                                  <div className="col-12 col-md-6 livSingleDateEdit">
                                    <button className="btn btn-outline-secondary c-shipping-change-btn modal-link" onClick={(event) => handleOnlyLivingModal(event, oneSpecial, "noGroup")}>edit</button>
                                  </div>}
                              </div>
                            </div>
                          </div>
                        </>)
                      })}
                    </>
                    : ""}

                  {/* livingSpecialItemList */}
                  {deliveryDetailsRef.current?.displayLivingMaterialContent?.spLivingMaterialItemList?.length > 0 ?
                    <>

                      {deliveryDetailsRef.current?.displayLivingMaterialContent?.spLivingMaterialItemList.map((oneSpecial, index) => {
                        return (<>
                          <div className="row mb-3">
                            <div className="col-8 col-md-8">
                              <div className="c-delivery-item">
                                <span className="c-delivery-img">
                                  <img onError={replaceImage} src={oneSpecial?.imagePath} />
                                </span>
                                <div className="c-delivery-items c-delivery-items-weight">
                                  <p className="c-delivery-item-text fw-light">{`#${oneSpecial?.itemNumber}  Qty:${oneSpecial?.quantity}`}</p>
                                  <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: oneSpecial?.productDescription }}></p>
                                </div>
                              </div>
                            </div>
                            <div className="col-4 col-md-4 align-self-center">
                              <div className="row">
                                <div className="col-12 col-md-6">
                                  <p className="text-left mb-0 c-delivery-content">
                                    {handleDateFormat(oneSpecial?.deliveryDate)}
                                  </p>{livingShipMethodRef.current == "shipAllTogether" ? "" :
                                    <p className="text-left mb-0 c-delivery-content livShipMethod">{oneSpecial?.shippingMethod === "Second Day Air" ? "2 Day Air" : oneSpecial?.shippingMethod}</p>
                                  }
                                </div>
                                {livingShipMethodRef.current == "shipAllTogether" ? "" :
                                  <div className="col-12 col-md-6 livSingleDateEdit">
                                 {oneSpecial?.shippingMethod == "USPS" ? "" :
                                    <button onClick={(event) => handleOnlyLivingModal(event, oneSpecial, "noGroup")} className="btn btn-outline-secondary c-shipping-change-btn modal-link">edit</button>
                                 }</div>}
                              </div>
                            </div>
                          </div>
                        </>)
                      })}
                    </> : ""}
                </div>

              </> : ""}

              {deliveryDetailsRef.current && deliveryDetailsRef.current?.displayNonLivingContent?.nonLiveGroupItemList?.length > 0 ?
                <>
                  <div className="row">
                    <div className="col-12 col-md-12 text-left mb-3 ">
                      <h1 className="c-account-heading fw-bold">
                        Your In-Stock, Non-Perishable Items
                      </h1>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 col-md-12 text-left mb-3">
                      <h1 className="c-account-heading fw-normal">Select your shipping preference:</h1>
                    </div>
                  </div>
                  {/* form ship need to handle start */}
                  <form className="row g-4">

                    <label className='col-12 col-md-6' htmlFor="ship-immediately" onClick={(event) => handleShipImmediately(event, "ship-Immediate")}>
                      <div className={`c-box-shipping ${nonLivingShipMethodRef.current == 'ship-Immediate' && 'active'}`} id="ship-Immediate">
                        <div className="form-check">
                          <input className="form-check-input"
                            type="radio"
                            id='ship-immediately'
                            name="shippingPrefernce"
                            value="shipImmediate"
                            checked={nonLivingShipMethodRef.current == 'ship-Immediate'}
                            defaultChecked={nonLivingShipMethodRef.current == 'ship-Immediate'}
                            onChange={() => setNonLivingShipMethod("ship-Immediate")}

                          />

                          <div className="form-check-label fw-bold">
                            Ship Immediately
                          </div>
                        </div>
                        <div className="c-box-shipping-calendar">
                          <p className="c-box-calendar-icon me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                              <g>
                                <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                  <title>calendar</title>
                                  <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                  </path>
                                </svg></g>
                              </g>





                            </svg>
                          </p>
                          <div className="c-box-calendar-info">
                            <p>Leaves our facility</p><p>in 1-3 days</p>
                          </div>
                        </div>
                        <div className="container-circle">
                          <div className="circle">
                          </div>
                        </div>
                      </div>
                    </label>

                    <label className='col-12 col-md-6' htmlFor='ship-at-later-time' onClick={(event) => handleshipLater(event, "ship-Later")}>
                      <div className={`c-box-shipping ${nonLivingShipMethodRef.current == 'ship-Later' && 'active'}`} id="ship-Later">
                        <div className="form-check">
                          <input className="form-check-input"
                            type="radio"
                            id='ship-at-later-time'
                            name="shippingPrefernce"
                            value="shipLater"
                            checked={nonLivingShipMethodRef.current == 'ship-Later'}
                            defaultChecked={nonLivingShipMethodRef.current == 'ship-Later'}
                            onChange={(event) => handleshipLater(event, "ship-Later")}
                          />

                          <div className="form-check-label fw-bold" >
                            Ship at a Later Time
                          </div>
                        </div>
                        <div className="c-box-shipping-calendar">
                          <p className="c-box-calendar-icon me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                              <g>
                                <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 28" x="0px" y="0px">
                                  <title>calendar</title>
                                  <path d="M2 26h4.5v-4.5h-4.5v4.5zM7.5 26h5v-4.5h-5v4.5zM2 20.5h4.5v-5h-4.5v5zM7.5 20.5h5v-5h-5v5zM2 14.5h4.5v-4.5h-4.5v4.5zM13.5 26h5v-4.5h-5v4.5zM7.5 14.5h5v-4.5h-5v4.5zM19.5 26h4.5v-4.5h-4.5v4.5zM13.5 20.5h5v-5h-5v5zM8 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM19.5 20.5h4.5v-5h-4.5v5zM13.5 14.5h5v-4.5h-5v4.5zM19.5 14.5h4.5v-4.5h-4.5v4.5zM20 7v-4.5c0-0.266-0.234-0.5-0.5-0.5h-1c-0.266 0-0.5 0.234-0.5 0.5v4.5c0 0.266 0.234 0.5 0.5 0.5h1c0.266 0 0.5-0.234 0.5-0.5zM26 6v20c0 1.094-0.906 2-2 2h-22c-1.094 0-2-0.906-2-2v-20c0-1.094 0.906-2 2-2h2v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h6v-1.5c0-1.375 1.125-2.5 2.5-2.5h1c1.375 0 2.5 1.125 2.5 2.5v1.5h2c1.094 0 2 0.906 2 2z">
                                  </path>
                                </svg></g>
                              </g>
                            </svg>
                          </p>
                          {nonLivingShipMethodRef.current !== 'ship-Later' ?
                            <div className="btn btn-outline-secondary c-shipping-change-btn">Select Arrival Date</div>
                            : ""}
                          {nonLivingShipMethodRef.current === 'ship-Later' ?
                            <div className="c-box-calendar-info c-box-calendar-active-info">
                              <p>{deliveryDetailsRef.current?.displayNonLivingContent?.comDay}, {handleDateFormat(deliveryDetailsRef.current?.displayNonLivingContent?.comDate)}  </p>
                              <p>
                                Shipping:
                                {deliveryDetailsRef.current?.displayNonLivingContent?.shipMethod == "Standard Ground" ? "Ground" : deliveryDetailsRef.current?.displayNonLivingContent?.shipMethod}
                              </p>
                            </div>
                            : ""}
                          {nonLivingShipMethodRef.current === 'ship-Later' ?
                            <div className="btn btn-outline-secondary c-shipping-change-btn" id="select-arrival-button" onClick={(event) => handleNonLivingModal(event, deliveryDetailsRef.current?.displayNonLivingContent?.shipMethod)}>edit</div>
                            : ""}
                        </div>
                        <div className="container-circle">
                          <div className="circle">
                          </div>
                        </div>
                      </div>
                    </label>


                  </form>
                  {/* ended */}
                  {nonLivingShipMethodRef.current === 'ship-Immediate' ?
                    <div id="shippingMethods" className="c-shipping-box-small">
                      <div className="row mt-5">
                        <div className="col-12 col-md-12 text-left mb-3">
                          <h1 className="c-account-heading fw-normal">Select shipping method:</h1>
                        </div>
                      </div>
                      <form className="row">
                        <label className="col-12 col-md-4" htmlFor='standard-ground' onClick={(event) => handleNonLivingShippingMethod(event, 'Standard Ground')}>
                          <div className={`c-box-shipping ${nonLivingShipGroupMethodRef.current === 'Standard Ground' ? 'active' : ''}`} id="standard-ground-div">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                name="modifiedShippingMethod"
                                id="standard-ground"
                                type="radio"
                                value="Standard Ground"
                                checked={nonLivingShipGroupMethodRef.current === 'Standard Ground'}
                                defaultChecked={nonLivingShipGroupMethodRef.current === 'Standard Ground'}
                              />
                            </div>
                            <div className="c-box-shipping-calendar">
                              <p className="c-box-calendar-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100" className="calendar-svg">
                                  <g>
                                    <g transform="translate(50 50) scale(0.8 0.8) rotate(0) translate(-50 -50)">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333 333" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd">
                                        <g>
                                          <path d="M101 232c0,-18 -22,-21 -28,-7 -4,8 1,18 10,20 9,2 18,-6 18,-13zm143 -16c-18,0 -21,22 -7,28 6,3 13,1 16,-3 10,-10 1,-25 -9,-25zm-104 -65l0 -26c0,-1 0,-2 -2,-2 -27,0 -22,-2 -28,7 -4,5 -7,10 -11,16 -2,3 -6,7 -2,7l41 0c2,0 2,0 2,-2zm159 -56l0 135c0,12 -19,9 -27,9 -3,14 -17,23 -30,22 -22,-1 -28,-22 -30,-22l-95 0c-4,0 -6,21 -30,22 -13,1 -27,-9 -30,-22 -4,0 -13,1 -17,0 -3,-1 -8,-5 -8,-9l0 -17c0,-6 5,-10 10,-11 0,-10 -2,-30 3,-39 7,-12 26,-8 30,-12 1,0 4,-5 5,-6 8,-13 20,-37 36,-37l43 0c0,-10 -2,-24 12,-24l115 0c7,0 13,4 13,11z">
                                          </path>
                                        </g>
                                      </svg>
                                    </g>
                                  </g>
                                </svg>
                              </p>

                              <div className="c-box-calendar-info m-0">
                                <p className="fw-bold">Standard Ground</p>
                                <p> 3-5 days
                                </p>
                              </div>
                            </div>

                          </div>
                        </label>

                        <label className="col-12 col-md-4" htmlFor='second-day-air' onClick={(event) => handleNonLivingShippingMethod(event, 'Second Day Air')}>
                          <div className={`c-box-shipping ${nonLivingShipGroupMethodRef.current === 'Second Day Air' ? 'active' : ''}`} id="second-day-air-div" >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                name="modifiedShippingMethod"
                                id="second-day-air"
                                type="radio"
                                value="2 Day Air"
                                checked={nonLivingShipGroupMethodRef.current === 'Second Day Air'}
                                defaultChecked={nonLivingShipGroupMethodRef.current === 'Second Day Airr'}

                              />
                            </div>
                            <div className="c-box-shipping-calendar">
                              <p className="c-box-calendar-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100">
                                  <g><g transform="translate(50 50) scale(0.5 0.5) rotate(0) translate(-50 -50)">
                                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="370.9 247.6 100 100" enable-background="new 370.9 247.6 100 100">
                                      <g><path d="M469.8,269.8l-9-6.5c-0.5-0.3-1-0.5-1.9-0.5l-53,4.4c-5-5-19.4-18.7-28.1-18.7c-2,0-3.7,0.7-5,1.9    c-1.3,1.3-1.9,3.1-1.9,5.1c0.1,8.5,13.7,22.6,18.6,27.4l-4.3,53.6c0,0.6,0.1,1.2,0.4,1.7l4.5,7.3c0.5,0.8,1.4,1.3,2.4,1.3    c0.1,0,0.3,0,0.4,0c1.1-0.1,2-0.9,2.3-1.9l13.4-43.9l25.5,20.1l0.3,18c0,0.6,0.2,1.2,0.6,1.7l2.7,3.2c0.5,0.6,1.2,0.9,2.3,1    c0.9-0.1,1.7-0.5,2.2-1.3l9.3-14.9l14.4-9c0.8-0.5,1.2-1.3,1.3-2.2c0.1-0.9-0.3-1.8-1-2.3l-3.1-2.7c-0.5-0.4-1-0.6-1.6-0.7    l-17.3-1.1l-20.7-24.6l45.3-11.5c1-0.3,1.8-1.1,2.1-2.2C471.1,271.6,470.6,270.5,469.8,269.8z">
                                      </path></g>
                                    </svg></g></g>
                                </svg>
                              </p>

                              <div className="c-box-calendar-info m-0">
                                <p className="fw-bold">2 Day Air </p>
                                <p> 2 day</p>
                              </div>
                            </div>
                          </div>
                        </label>

                        <label className="col-12 col-md-4" htmlFor='overnight' onClick={(event) => handleNonLivingShippingMethod(event, 'Overnight')}>
                          <div className={`c-box-shipping ${nonLivingShipGroupMethodRef.current === 'Overnight' ? 'active' : ''}`} id="overnight-div" >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                name="modifiedShippingMethod"
                                id="overnight"
                                type="radio"
                                value="Overnight"
                                checked={nonLivingShipGroupMethodRef.current === 'Overnight'}
                                defaultChecked={nonLivingShipGroupMethodRef.current === 'Overnight'}

                              />
                            </div>
                            <div className="c-box-shipping-calendar">
                              <p className="c-box-calendar-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 100 100">
                                  <g>
                                    <g transform="translate(50 50) scale(0.5 0.5) rotate(0) translate(-50 -50)" >
                                      <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="370.9 247.6 100 100" enable-background="new 370.9 247.6 100 100" >
                                        <g><path d="M469.8,269.8l-9-6.5c-0.5-0.3-1-0.5-1.9-0.5l-53,4.4c-5-5-19.4-18.7-28.1-18.7c-2,0-3.7,0.7-5,1.9    c-1.3,1.3-1.9,3.1-1.9,5.1c0.1,8.5,13.7,22.6,18.6,27.4l-4.3,53.6c0,0.6,0.1,1.2,0.4,1.7l4.5,7.3c0.5,0.8,1.4,1.3,2.4,1.3    c0.1,0,0.3,0,0.4,0c1.1-0.1,2-0.9,2.3-1.9l13.4-43.9l25.5,20.1l0.3,18c0,0.6,0.2,1.2,0.6,1.7l2.7,3.2c0.5,0.6,1.2,0.9,2.3,1    c0.9-0.1,1.7-0.5,2.2-1.3l9.3-14.9l14.4-9c0.8-0.5,1.2-1.3,1.3-2.2c0.1-0.9-0.3-1.8-1-2.3l-3.1-2.7c-0.5-0.4-1-0.6-1.6-0.7    l-17.3-1.1l-20.7-24.6l45.3-11.5c1-0.3,1.8-1.1,2.1-2.2C471.1,271.6,470.6,270.5,469.8,269.8z">
                                        </path></g>
                                      </svg></g>
                                  </g>
                                </svg>
                              </p>

                              <div className="c-box-calendar-info m-0">
                                <p className="fw-bold">Overnight</p>
                                <p>next day </p>
                              </div>
                            </div>
                          </div>
                        </label>
                      </form>
                    </div>
                    : ""}


                  <div className="row mt-5">
                    <div className="col-8 col-md-8"></div>
                    <div className="col-4 col-md-4">
                      <p className="text-left mb-2 c-delivery-text">Arrival Date</p>
                    </div>
                  </div>
                  <div className="mb-10">
                    {deliveryDetailsRef.current?.displayNonLivingContent?.nonLiveGroupItemList.map((oneProduct) => {
                      return (<>
                        <div className="row mb-3">
                          <div className="col-8 col-md-8">
                            <div className="c-delivery-item">
                              <span className="c-delivery-img">
                                <img fetchpriority="high" onError={replaceImage} src={oneProduct?.imagePath} />
                              </span>
                              <div className="c-delivery-items c-delivery-items-weight">
                                {
                                  oneProduct?.isHazardousItem && oneProduct?.isHazardousItem == true ?
                                    <p class="c-delivery-item-text">{deliveryDetailsRef.current?.displayMessagesMap?.deliveryHazaroudOnly}</p>
                                    : ""
                                }
                                <p className="c-delivery-item-text fw-light">#{oneProduct?.itemNumber}  Qty:{oneProduct?.quantity}</p>
                                <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: oneProduct?.productDescription }}>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-4 col-md-4 align-self-center">
                            <div className="row">
                              <div className="col-12 col-md-12 d-flex">
                                {handleDateCompare(oneProduct?.arrivalStartDate, oneProduct?.arrivalEndDate) == "equal" ?
                                  <p className="text-left mb-0 c-delivery-content">{handleDateFormat(oneProduct?.arrivalStartDate)}</p> :
                                  deliveryDetailsRef.current?.displayNonLivingContent?.shippingPreferenceForNonLiving == "ship-Later" ?
                                    <p className="text-left mb-0 c-delivery-content">{handleDateFormat(oneProduct?.arrivalStartDate)}</p> :
                                    <p className="text-left mb-0 c-delivery-content">
                                      {handleDateFormat(oneProduct.arrivalStartDate).concat(" - ").concat(handleDateFormat(oneProduct.arrivalEndDate))}
                                    </p>
                                }
                              </div>
                            </div>
                          </div>
                        </div></>)
                    })}

                  </div>
                </>

                : ""}
              <div className="row g-3 mb-3 mt-3">
                <form method="POST" name="delivery_form" onSubmit={handleSubmitContinue} id="delivery_form_id" >
                  <div className="col-md-6 d-grid">
                    <input name="moveToBilling" type="submit" value="Continue" className="btn btn-primary block" />
                  </div>
                </form>
              </div>

              <div className="row g-3 mb-3 mt-3">

              </div>
            </div>

            <OrderSummary isOrderSummaryLoading={isOrderSummaryLoadingRef.current} orderSummaryDetails={orderSummaryDetailsRef.current} myOrderBoxFix={myOrderBoxFix} handleCallBackOrderSummary={handleCallBackOrderSummary} />
          </div>
        </div>
      </div>
      {nonLivingMapRef.current ? <NonLivingCalenderV1 currentData={nonLivingMapRef.current} handleOrderDetails={handleOrderDetails} /> : ""}
      {onlyLivingMapRef.current ? <LivingCalendarModalV1 currentData={onlyLivingMapRef.current} handleOrderDetails={handleOrderDetails} /> : ""}

    </div >
  )
}

export default CheckOutDeliveryV1